import angular from 'angular';
import uiRouter from 'angular-ui-router';
import socialPageComponent from './socialPage.component';

let socialPageModule = angular.module('socialPage', [
  uiRouter
])

.component('socialPage', socialPageComponent)

.name;

export default socialPageModule;
